import { SAVE_WEBCHAT_DATA } from "./const";

const saveWebchatData = value => dispatch => {
  dispatch({ type: SAVE_WEBCHAT_DATA, value });
};

export default {
  saveWebchatData,
};
